if (!customElements.get('cart-caution-modal')) {
  customElements.define(
    'cart-caution-modal',
    class CartCautionModal extends HTMLElement {
      constructor() {
        super();
        this._resolver = null;
      }

      connectedCallback() {
        this.backdrop   = this.querySelector('[data-cart-caution-backdrop]');
        this.closeBtn   = this.querySelector('[data-cart-caution-close]');
        this.cancelBtn  = this.querySelector('[data-cart-caution-cancel]');
        this.confirmBtn = this.querySelector('[data-cart-caution-confirm]');
        this.checkbox   = this.querySelector('[data-cart-caution-check]');
        this.dialog     = this.querySelector('[role="dialog"]');

        this.backdrop?.addEventListener('click', () => this.dismiss());
        this.closeBtn?.addEventListener('click', () => this.dismiss());
        this.cancelBtn?.addEventListener('click', () => this.dismiss());
        this.confirmBtn?.addEventListener('click', () => this.confirm());
        this.checkbox?.addEventListener('change', () => this.syncConfirmState());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) {
            this.dismiss();
          }
        });
      }

      // 商品ページ以外では画像を data-src で保持しているため、初回表示時に読み込む
      loadDeferredImage() {
        const image = this.querySelector('img[data-src]');
        if (!image) return;

        image.src = image.dataset.src;
        image.removeAttribute('data-src');
      }

      open({ confirmLabel = '確認してカートに追加' } = {}) {
        return new Promise((resolve) => {
          this._resolver = resolve;
          this.loadDeferredImage();
          if (this.checkbox) this.checkbox.checked = false;
          if (this.confirmBtn && confirmLabel) {
            this.confirmBtn.textContent = confirmLabel;
          }
          this.syncConfirmState();
          this.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
          requestAnimationFrame(() => {
            this.dialog?.focus();
          });
        });
      }

      syncConfirmState() {
        if (!this.confirmBtn || !this.checkbox) return;
        this.confirmBtn.disabled = !this.checkbox.checked;
      }

      confirm() {
        if (this.checkbox && !this.checkbox.checked) return;
        this.close(true);
      }

      dismiss() {
        this.close(false);
      }

      close(confirmed) {
        this.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        if (this._resolver) {
          this._resolver(confirmed);
          this._resolver = null;
        }
      }
    }
  );
}
